import { useContext } from "react";
import { motion } from "framer-motion";
import { LanguageContext } from "../../../context/LanguageContext";
import dashboard from "../../logo copy/teqa_connect.png";

export default function Hero() {
  const { t, isRTL } = useContext(LanguageContext);

  return (
    <section dir={isRTL ? "rtl" : "ltr"} className="bg-white overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 py-20">
        <div className="grid grid-cols-1 items-center gap-16 md:grid-cols-2">

          {/* LEFT CONTENT */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
          >
            {/* Badge */}
            <motion.span
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.2 }}
              className="inline-block rounded-full bg-indigo-50 px-4 py-1 text-sm font-medium text-indigo-600"
            >
              {t("hero.badge")}
            </motion.span>

            {/* Title */}
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.7 }}
              className="mt-6 text-5xl font-extrabold leading-tight tracking-tight text-black md:text-6xl"
            >
              {t("hero.title.line1")}<br />
              {t("hero.title.line2")}<br />
              {t("hero.title.line3")}<br />
              {t("hero.title.line4")}
            </motion.h1>

            {/* Description */}
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5 }}
              className="mt-6 max-w-xl text-lg text-gray-600"
            >
              {t("hero.description")}
            </motion.p>

            {/* CTA Buttons */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6 }}
              className={`mt-8 flex items-center gap-4 ${isRTL ? "flex-row-reverse" : ""}`}
            >
              <a
                href="/register"
                className="rounded-lg bg-indigo-600 px-6 py-3 font-semibold text-white hover:bg-indigo-700 transition"
              >
                {t("hero.cta.primary")}
              </a>

              <button className="rounded-lg border border-gray-300 px-6 py-3 font-semibold text-gray-700 hover:bg-gray-50 transition">
                {t("hero.cta.secondary")}
              </button>
            </motion.div>

            {/* Footer text */}
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.8 }}
              className="mt-4 text-sm text-gray-500"
            >
              {t("hero.footerNote")}
            </motion.p>
          </motion.div>

          {/* RIGHT CONTENT */}
          <motion.div
            initial={{ opacity: 0, x: isRTL ? -60 : 60 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="relative"
          >
            <motion.div
              animate={{ y: [0, -10, 0] }}
              transition={{ repeat: Infinity, duration: 4, ease: "easeInOut" }}
              className="flex h-[420px] w-full items-center justify-center rounded-2xl"
            >
              <img src={dashboard} alt="Teqa dashboard" />
            </motion.div>
          </motion.div>

        </div>
      </div>
    </section>
  );
}
